import type { ReactNode } from 'react';

export const repeat = (n: number, element: ReactNode): ReactNode[] =>
  /* TODO: Arreglar tipos */
  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  /* @ts-ignore */
  [...Array(n)].map((_, i) => <element.type {...element.props} key={i} />);

export const generateImages = (
  length: number = 10,
  sig: number = 0,
): {
  src: string;
  alt: string;
  width: number;
  height: number;
}[] =>
  Array.from({ length }).map((_, index) => {
    index = sig || index;

    return {
      src: `https://source.unsplash.com/random/800x450?sig=${index}`,
      alt: `Image ${index}`,
      width: 800,
      height: 450,
    };
  });
